module.exports = __webpack_public_path__ + "static/media/mon1.f634b2e1.png";